// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__qomiF","selected":"Chip_selected__tN6KM"};